import { CloseIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiChipOverrides = {
  MuiChip: {
    defaultProps: {
      deleteIcon: /*#__PURE__*/jsx(CloseIcon, {}),
      color: 'gray',
      size: 'small'
    },
    styleOverrides: {
      sizeSmall: {
        height: 16
      },
      sizeMedium: {
        height: 20
      },
      outlined: ({
        theme,
        ownerState
      }) => ({
        borderWidth: '1.5px',
        color: theme.palette.darkBlue,
        ...(ownerState.color === 'gray' && {
          borderColor: theme.palette.gray70
        }),
        ...(ownerState.color === 'black' && {
          borderColor: theme.palette.darkBlue
        }),
        ...(ownerState.color === 'green' && {
          borderColor: theme.palette.green30
        }),
        ...(ownerState.color === 'orange' && {
          borderColor: theme.palette.orangeBase
        }),
        ...(ownerState.color === 'red' && {
          borderColor: theme.palette.redBase
        }),
        ...(ownerState.color === 'blue' && {
          borderColor: theme.palette.blueBase
        })
      }),
      label: ({
        theme
      }) => ({
        ...theme.typography.caption,
        padding: theme.spacing(0, 0.75)
      }),
      icon: ({
        theme,
        ownerState
      }) => ({
        fontSize: theme.spacing(1.5),
        color: theme.palette.white,
        marginLeft: theme.spacing(0.5),
        marginRight: 0,
        ...(ownerState.color === 'gray' && {
          color: theme.palette.darkBlue
        }),
        ...(ownerState.color === 'yellow' && {
          color: theme.palette.darkBlue
        }),
        ...(ownerState.variant === 'outlined' && {
          ...(ownerState.color === 'black' && {
            color: theme.palette.darkBlue
          }),
          ...(ownerState.color === 'green' && {
            color: theme.palette.green30
          }),
          ...(ownerState.color === 'orange' && {
            color: theme.palette.orangeBase
          }),
          ...(ownerState.color === 'red' && {
            color: theme.palette.redBase
          }),
          ...(ownerState.color === 'blue' && {
            color: theme.palette.blueBase
          })
        })
      }),
      deleteIcon: ({
        theme,
        ownerState
      }) => ({
        fontSize: theme.spacing(1.5),
        marginLeft: -2,
        ...(ownerState.variant === 'outlined' && {
          color: theme.palette.gray70,
          '&:hover': {
            color: theme.palette.darkBlue
          }
        })
      })
    }
  }
};

export { MuiChipOverrides };
